// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__21MHG","title":"FrontImage_title__2MM14"};